// extracted by css-extract-rspack-plugin
export default {"link":"_53d45e10","img":"_d287f973"};